module.exports = __webpack_public_path__ + "media/widget/gift_white-7aeb6ba6.svg";